import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App';
import store from './store';
import vuetify from './plugins/vuetify';
import routes from './router/index';
import '@mdi/font/css/materialdesignicons.css'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import InfiniteLoading from 'vue-infinite-loading';

Vue.use(InfiniteLoading); 
 
Vue.use(VueMoment, {
    moment,
})
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    //this route requires auth, check if logged in, redirect to login if not
    if(!store.getters.loggedIn) {
      next({
        name: 'login'
      });
    } else {
      next();
    }
  } else if(to.matched.some(record => record.meta.requiresVisitor)) {
    //this route requires auth, check if logged in, redirect to login if not
    if(store.getters.loggedIn) {
      next({
        name: 'home'
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

new Vue({
  el: '#app',
  router: router,
  store: store,
  iconfont: 'mdi',
  vuetify,
  render: app => app(App)
});